import { useTranslation } from '@centric-os/helpers';
import * as yup from 'yup';
import { SitesLocalePrefix } from '../../../enums';

export default () => {
  const { translate } = useTranslation();
  const LOCALE_PREFIX = SitesLocalePrefix.SITE_DROP_OFF;

  const schema = yup.object().shape({
    delivery_destinations: yup
      .array()
      .min(1, translate(`${LOCALE_PREFIX}.timeslots.minimumLocationSelect`))
      .required(translate(`${LOCALE_PREFIX}.timeslots.minimumLocationSelect`)),
  });

  return {
    schema,
  };
};
